<div class="ld" role="status" aria-label="Loading Little Nap Recliners">
  <div class="ld__box">
    <svg class="ld__ring" viewBox="0 0 54 54" aria-hidden="true">
      <circle cx="27" cy="27" r="25.5" />
      <circle class="ld__fill" cx="27" cy="27" r="25.5" pathLength="100" />
    </svg>
    <!-- (the back-to-top button's chair: back, footrest, seat, arm and its post, pedestal, base — and its dozing z's) -->
    <svg class="ld__chair" viewBox="0 0 48 40" aria-hidden="true">
      <rect class="ld__back" x="16" y="6" width="6.6" height="21" rx="3.3" />
      <rect class="ld__foot" x="32" y="23" width="5" height="11" rx="2.5" />
      <rect x="17" y="21.5" width="18" height="6.8" rx="3.2" />
      <rect x="18.5" y="16.4" width="12.5" height="3.6" rx="1.8" />
      <rect x="26.6" y="18" width="2.8" height="5" rx="1.4" />
      <rect x="24" y="28" width="3.4" height="4.6" />
      <rect x="18" y="32" width="15.4" height="2.8" rx="1.4" />
      <text class="ld__z" x="13" y="8">z</text>
      <text class="ld__z ld__z--late" x="19" y="4">z</text>
    </svg>
  </div>

  <p class="ld__name" aria-hidden="true">
    @for (letter of name; track $index) {
      <span class="ld__mask"><span class="ld__letter" [style.--i]="$index">{{ letter === ' ' ? ' ' : letter }}</span></span>
    }
  </p>
  <p class="ld__tag" aria-hidden="true">Recliners</p>
</div>
